import "./__thumbnail.scss"
import "./__thumbnail.coffee"
